import { render, staticRenderFns } from "./TableItem.vue?vue&type=template&id=591d2d48&scoped=true&"
import script from "./TableItem.vue?vue&type=script&lang=ts&"
export * from "./TableItem.vue?vue&type=script&lang=ts&"
import style0 from "./TableItem.vue?vue&type=style&index=0&id=591d2d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d2d48",
  null
  
)

export default component.exports